/**
 * Coach Logic system user constants
 * These values match the backend COACH_LOGIC_SYSTEM_USER constant
 */
export const COACH_LOGIC_ID = 'coachLogic'
export const COACH_LOGIC_ID_LEGACY = 'Coach Logic'

/**
 * Array of all possible Coach Logic IDs (for checking)
 */
export const COACH_LOGIC_IDS = [COACH_LOGIC_ID, COACH_LOGIC_ID_LEGACY] as const
